import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useDeviceType from '../../../hooks/useDeviceType';

const useNavigationDrawer = () => {
  const location = useLocation();

  const getNormalizedRoute = (pathname: string): string => {
    if (pathname.startsWith('/klydo/')) {
      return '/klydos';
    }
    if (pathname.startsWith('/collection/')) {
      return '/collections';
    }
    return pathname;
  };

  const currentRoute = getNormalizedRoute(location.pathname);
  const { isSmallLaptop } = useDeviceType();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);

  const navigate = useNavigate();

  const toggleDrawer = (open: boolean) => {
    setIsDrawerOpen(open);
  };

  const handleClick = (route: string, externalUrl?: string) => {
    if (externalUrl) {
      window.open(externalUrl, '_blank', 'noopener,noreferrer');
    } else {
      navigate(route);
    }
    if (isSmallLaptop) toggleDrawer(false);
  };

  return {
    toggleDrawer,
    isDrawerOpen,
    handleClick,
    isHelpDialogOpen,
    setIsHelpDialogOpen,
    currentRoute,
  };
};

export default useNavigationDrawer;
